"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseRecommendationResponse = exports.parseProductCharacteristic = exports.isSpecIncludedInSpecGroup = exports.formatSpecValues = void 0;
var _constants = require("../../utils/constants");
var _utils = require("../../utils/utils");
var _services = require("../../services");
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _lodash2 = _interopRequireDefault(require("lodash.groupby"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let config = {};
const getRecommendationTier = recommendationItem => {
  return recommendationItem.category.find(categoryItem => categoryItem['@type'] === 'tier').id;
};

/**
 * Maps over the values of a specification and replaces the values with the UNLIMITED_VALUE constant if isCharacteristicUnlimited is set to true.
 * @param {any} characteristic
 * @param {boolean} isCharacteristicUnlimited
 * @returns {any}
 */
const formatSpecValues = (characteristic, isCharacteristicUnlimited) => {
  const specValues = characteristic.value.map(val => {
    var _val$value;
    return {
      ...val,
      value: isCharacteristicUnlimited ? _constants.UNLIMITED_VALUE : (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : val
    };
  });
  return specValues;
};
exports.formatSpecValues = formatSpecValues;
const formatValueText = (groupedValues, isCharacteristicUnlimited) => {
  let textValue = '';
  if (isCharacteristicUnlimited) {
    textValue += _services.Services.locale.localeString(`Specs.unlimited`);
    return textValue;
  }
  Object.entries(groupedValues).forEach((_ref, index) => {
    let [key, value] = _ref;
    if (key !== 'undefined' && key !== '') {
      const values = value.length > 1 ? value.join('/') : value[0];
      if (values) {
        // Check if the text already includes the unit key (case insensitive)
        const unitString = _services.Services.locale.localeString(`Units.${key}`, key);
        const hasUnit = values.toString().toLowerCase().includes(unitString === null || unitString === void 0 ? void 0 : unitString.toLowerCase());

        // Only add the unit if it's not already in the text
        textValue += hasUnit ? values : `${values} ${unitString}`;
      }
      if (index !== Object.entries(groupedValues).length - 1) {
        textValue += ',';
      }
    } else {
      const values = value.length > 1 ? value.join(',') : value[0];
      textValue += `${values || ''}`;
    }
  });
  return textValue;
};
const groupByUnit = function () {
  let characteristicValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return characteristicValues.reduce((group, value) => {
    var _group$unitOfMeasure;
    const {
      unitOfMeasure
    } = value;
    group[unitOfMeasure] = (_group$unitOfMeasure = group[unitOfMeasure]) !== null && _group$unitOfMeasure !== void 0 ? _group$unitOfMeasure : [];
    group[unitOfMeasure].push(value.value);
    group[unitOfMeasure].sort((a, b) => a - b);
    return group;
  }, {});
};

/**
 * Will return a boolean value indicating whether a characteristic is included in a spec group as well as if the specification relationships, if they exist, contain the spec group
 * @param {any} specGroup
 * @param {any} characteristic
 * @returns {boolean}
 */
const isSpecIncludedInSpecGroup = (specGroup, characteristic) => specGroup.characteristics.find(spec => {
  var _characteristic$chara, _characteristic$chara2;
  return spec.name === characteristic.name && (((_characteristic$chara = characteristic.characteristicRelationship) === null || _characteristic$chara === void 0 ? void 0 : _characteristic$chara.some(charGroup => charGroup.id === specGroup.name)) || !((_characteristic$chara2 = characteristic.characteristicRelationship) !== null && _characteristic$chara2 !== void 0 && _characteristic$chara2[0]));
});
exports.isSpecIncludedInSpecGroup = isSpecIncludedInSpecGroup;
const parseProductCharacteristic = (characteristic, specGroups) => {
  var _characteristic$chara3, _characteristic$chara4, _characteristic$value, _groupedCharacteristi;
  const iconName = _constants.CHARACTERISTIC_ICON_MAP[characteristic.name] || 'mobile';
  const groupedValues = groupByUnit(characteristic.value);
  const groups = (_characteristic$chara3 = (_characteristic$chara4 = characteristic.characteristicRelationship) === null || _characteristic$chara4 === void 0 ? void 0 : _characteristic$chara4.map(item => item.id)) !== null && _characteristic$chara3 !== void 0 ? _characteristic$chara3 : [];
  const isCharacteristicUnlimited = groups.includes(_constants.UNLIMITED_GROUP_NAME);
  const valueText = characteristic.name === 'condition' ? (_characteristic$value = characteristic.value.find(value => {
    return value.isDefault || characteristic.value.length === 1;
  })) === null || _characteristic$value === void 0 ? void 0 : _characteristic$value.value : formatValueText(groupedValues, isCharacteristicUnlimited);
  const fullText = `${(0, _utils.capitalize)(characteristic.name)}: ${valueText}`;
  const groupedCharacteristic = specGroups.map(specGroup => {
    return specGroup.characteristics.find(spec => {
      var _characteristic$chara5, _characteristic$chara6;
      return spec.name === characteristic.name && (((_characteristic$chara5 = characteristic.characteristicRelationship) === null || _characteristic$chara5 === void 0 ? void 0 : _characteristic$chara5.some(charGroup => charGroup.id === specGroup.name)) || !((_characteristic$chara6 = characteristic.characteristicRelationship) !== null && _characteristic$chara6 !== void 0 && _characteristic$chara6[0]));
    }) && specGroup;
  }).filter(el => el !== undefined);
  const fullSpecGroup = groupedCharacteristic === null || groupedCharacteristic === void 0 ? void 0 : (_groupedCharacteristi = groupedCharacteristic[0]) === null || _groupedCharacteristi === void 0 ? void 0 : _groupedCharacteristi.name;
  return {
    ...characteristic,
    value: formatSpecValues(characteristic, isCharacteristicUnlimited),
    groups,
    fullSpecGroup,
    iconName,
    valueText,
    fullText
  };
};
exports.parseProductCharacteristic = parseProductCharacteristic;
const parseFilterCharacteristic = (characteristic, product) => {
  if (characteristic) {
    return {
      ...characteristic,
      variantId: product.id
    };
  }
};
const getProductCharacteristic = (product, specGroups) => characteristicName => {
  const characteristic = product.productCharacteristic.find(char => char.name === characteristicName);
  return characteristic && parseProductCharacteristic(characteristic, specGroups);
};
const getMainCharacteristics = characteristics => {
  const {
    topFeatures: topFeaturesListConfig
  } = config;
  const DEFAULT_ORDER = 9999;
  const topFeaturesConfig = {};
  topFeaturesListConfig === null || topFeaturesListConfig === void 0 ? void 0 : topFeaturesListConfig.forEach((feature, index) => {
    if (topFeaturesConfig[feature.name] === undefined) {
      topFeaturesConfig[feature.name] = {
        order: index,
        icon: feature.icon
      };
    }
  });
  return characteristics.filter(characteristic => characteristic.groups.includes('topFeature')).map(characteristic => {
    var _topFeaturesConfig$ch;
    return {
      ...characteristic,
      iconName: ((_topFeaturesConfig$ch = topFeaturesConfig[characteristic.name]) === null || _topFeaturesConfig$ch === void 0 ? void 0 : _topFeaturesConfig$ch.icon) || characteristic.iconName
    };
  }).sort((spec1, spec2) => {
    var _topFeaturesConfig$sp, _topFeaturesConfig$sp2, _topFeaturesConfig$sp3, _topFeaturesConfig$sp4;
    const specOrder1 = (_topFeaturesConfig$sp = (_topFeaturesConfig$sp2 = topFeaturesConfig[spec1.name]) === null || _topFeaturesConfig$sp2 === void 0 ? void 0 : _topFeaturesConfig$sp2.order) !== null && _topFeaturesConfig$sp !== void 0 ? _topFeaturesConfig$sp : DEFAULT_ORDER;
    const specOrder2 = (_topFeaturesConfig$sp3 = (_topFeaturesConfig$sp4 = topFeaturesConfig[spec2.name]) === null || _topFeaturesConfig$sp4 === void 0 ? void 0 : _topFeaturesConfig$sp4.order) !== null && _topFeaturesConfig$sp3 !== void 0 ? _topFeaturesConfig$sp3 : DEFAULT_ORDER;
    return specOrder1 - specOrder2;
  });
};
const getGroupedCharacteristics = characteristics => {
  const {
    specGroups: specGroupsListConfig
  } = config;
  const DEFAULT_ORDER = 9999;
  const groupConfig = {};
  const specConfig = {};
  const groupedSpecs = [];
  specGroupsListConfig.forEach((group, index) => {
    if (groupConfig[group.name] === undefined) {
      groupConfig[group.name] = {
        order: index
      };
    }
    group.characteristics.forEach((characteristic, index) => {
      if (specConfig[characteristic.name] === undefined) {
        specConfig[characteristic.name] = {
          order: index
        };
      }
    });
  });
  const specsWithGroups = characteristics.filter(spec => spec.fullSpecGroup && groupConfig[spec.fullSpecGroup] && spec.value !== undefined);
  const groups = (0, _lodash2.default)(specsWithGroups, spec => spec.fullSpecGroup);
  groupedSpecs.push(...Object.entries(groups).map(_ref2 => {
    let [groupName, specs] = _ref2;
    return {
      name: groupName,
      specs: specs.sort((spec1, spec2) => {
        var _specConfig$spec1$nam, _specConfig$spec1$nam2, _specConfig$spec2$nam, _specConfig$spec2$nam2;
        const specOrder1 = (_specConfig$spec1$nam = (_specConfig$spec1$nam2 = specConfig[spec1.name]) === null || _specConfig$spec1$nam2 === void 0 ? void 0 : _specConfig$spec1$nam2.order) !== null && _specConfig$spec1$nam !== void 0 ? _specConfig$spec1$nam : DEFAULT_ORDER;
        const specOrder2 = (_specConfig$spec2$nam = (_specConfig$spec2$nam2 = specConfig[spec2.name]) === null || _specConfig$spec2$nam2 === void 0 ? void 0 : _specConfig$spec2$nam2.order) !== null && _specConfig$spec2$nam !== void 0 ? _specConfig$spec2$nam : DEFAULT_ORDER;
        return specOrder1 - specOrder2;
      })
    };
  }).sort((group1, group2) => {
    var _groupConfig$group1$n, _groupConfig$group1$n2, _groupConfig$group2$n, _groupConfig$group2$n2;
    const groupOrder1 = (_groupConfig$group1$n = (_groupConfig$group1$n2 = groupConfig[group1.name]) === null || _groupConfig$group1$n2 === void 0 ? void 0 : _groupConfig$group1$n2.order) !== null && _groupConfig$group1$n !== void 0 ? _groupConfig$group1$n : DEFAULT_ORDER;
    const groupOrder2 = (_groupConfig$group2$n = (_groupConfig$group2$n2 = groupConfig[group2.name]) === null || _groupConfig$group2$n2 === void 0 ? void 0 : _groupConfig$group2$n2.order) !== null && _groupConfig$group2$n !== void 0 ? _groupConfig$group2$n : DEFAULT_ORDER;
    return groupOrder1 - groupOrder2;
  }));
  return groupedSpecs;
};
const mergeMainProductToVariants = mainProduct => {
  var _mainProduct$productR, _mainProduct$productR2;
  (_mainProduct$productR = mainProduct.productRelationship) === null || _mainProduct$productR === void 0 ? void 0 : (_mainProduct$productR2 = _mainProduct$productR.filter(relationshipItem => {
    return relationshipItem.relationshipType === 'alternative';
  })) === null || _mainProduct$productR2 === void 0 ? void 0 : _mainProduct$productR2.forEach(relationshipItem => {
    const variant = relationshipItem.product;
    // merge characteristics
    mainProduct.productCharacteristic.forEach(characteristic => {
      const characteristicExists = variant.productCharacteristic.find(variantCharacteristic => variantCharacteristic.name === characteristic.name);
      if (!characteristicExists) {
        variant.productCharacteristic.push((0, _utils.clone)(characteristic));
      }
    });

    // merge price
    if (!variant.productPrice) {
      variant.productPrice = (0, _utils.clone)(mainProduct.productPrice);
    }

    // merge product term
    if (!variant.productTerm) {
      variant.productTerm = mainProduct.productTerm ? (0, _utils.clone)(mainProduct.productTerm) : [];
    }
  });
};
const createFilterTree = (variants, category) => {
  if (category !== 'handset') {
    return;
  }
  /**
   * 1. Find unique colors
   * 2. For each color find its memory variants, sort them by value, add them as children to color
   * 3. Assign as default color variantId the first memory variantId
   */
  return (0, _lodash.default)(variants, variant => {
    var _variant$color$value$, _variant$color$value, _variant$color$value2;
    const defaultValue = (_variant$color$value$ = (_variant$color$value = variant.color.value) === null || _variant$color$value === void 0 ? void 0 : _variant$color$value.find(value => value.isDefault)) !== null && _variant$color$value$ !== void 0 ? _variant$color$value$ : (_variant$color$value2 = variant.color.value) === null || _variant$color$value2 === void 0 ? void 0 : _variant$color$value2[0];
    return defaultValue.value;
  }).map(variant => {
    var _variant$color$value$2, _variant$color$value3, _variant$color$value4, _variant$characterist, _variant$characterist2;
    const defaultValue = (_variant$color$value$2 = (_variant$color$value3 = variant.color.value) === null || _variant$color$value3 === void 0 ? void 0 : _variant$color$value3.find(value => value.isDefault)) !== null && _variant$color$value$2 !== void 0 ? _variant$color$value$2 : (_variant$color$value4 = variant.color.value) === null || _variant$color$value4 === void 0 ? void 0 : _variant$color$value4[0];
    return {
      id: variant.color.id,
      name: variant.color.name,
      value: [defaultValue],
      refurbishedCondition: (_variant$characterist = variant.characteristics) === null || _variant$characterist === void 0 ? void 0 : (_variant$characterist2 = _variant$characterist.find(c => c.id === 'condition')) === null || _variant$characterist2 === void 0 ? void 0 : _variant$characterist2.valueText
    };
  }).map(color => ({
    ...color,
    variants: variants.filter(variant => {
      var _variant$color, _variant$color$value5, _variant$color$value6, _variant$color$value7, _color$value$0$value, _variant$memory, _variant$memory$value;
      return (variant === null || variant === void 0 ? void 0 : (_variant$color = variant.color) === null || _variant$color === void 0 ? void 0 : (_variant$color$value5 = _variant$color.value) === null || _variant$color$value5 === void 0 ? void 0 : (_variant$color$value6 = _variant$color$value5.find(c => c.isDefault)) === null || _variant$color$value6 === void 0 ? void 0 : (_variant$color$value7 = _variant$color$value6.value) === null || _variant$color$value7 === void 0 ? void 0 : _variant$color$value7.split('|')[1]) === ((_color$value$0$value = color.value[0].value) === null || _color$value$0$value === void 0 ? void 0 : _color$value$0$value.split('|')[1]) && (variant === null || variant === void 0 ? void 0 : (_variant$memory = variant.memory) === null || _variant$memory === void 0 ? void 0 : (_variant$memory$value = _variant$memory.value) === null || _variant$memory$value === void 0 ? void 0 : _variant$memory$value.find(m => m.isDefault));
    }).map(variant => {
      var _variant$memory2, _variant$memory2$valu, _variant$characterist3, _variant$characterist4;
      return {
        id: variant.memory.id,
        name: variant.memory.name,
        value: variant === null || variant === void 0 ? void 0 : (_variant$memory2 = variant.memory) === null || _variant$memory2 === void 0 ? void 0 : (_variant$memory2$valu = _variant$memory2.value) === null || _variant$memory2$valu === void 0 ? void 0 : _variant$memory2$valu.find(m => m.isDefault),
        variantId: variant.memory.variantId,
        refurbishedCondition: (_variant$characterist3 = variant.characteristics) === null || _variant$characterist3 === void 0 ? void 0 : (_variant$characterist4 = _variant$characterist3.find(c => c.id === 'condition')) === null || _variant$characterist4 === void 0 ? void 0 : _variant$characterist4.valueText
      };
    }).sort((a, b) => a.value - b.value)
  })).map(color => {
    var _color$variants$;
    return {
      ...color,
      variantId: color === null || color === void 0 ? void 0 : (_color$variants$ = color.variants[0]) === null || _color$variants$ === void 0 ? void 0 : _color$variants$.variantId
    };
  });
};
const getDiscountPriceAlteration = (priceItem, category) => {
  var _priceItem$productPri;
  const discountPriceType = category === _constants.PRODUCT_TYPES.BROADBAND.toLocaleLowerCase() ? _constants.PRICE_TYPES.MONTHLY_DISCOUNT : _constants.PRICE_TYPES.CUSTOMER_DISCOUNT;
  return priceItem === null || priceItem === void 0 ? void 0 : (_priceItem$productPri = priceItem.productPriceAlteration) === null || _priceItem$productPri === void 0 ? void 0 : _priceItem$productPri.find(price => price.priceType === discountPriceType);
};
const createVariant = (product, attachment, specGroups, category) => {
  var _getCharacteristic, _getCharacteristic2, _getCharacteristic2$v, _getCharacteristic2$v2;
  const getCharacteristic = getProductCharacteristic(product, specGroups);
  const variantId = product.id;
  const productName = product.name;
  const productDescription = product.description;
  const media = attachment;
  const color = parseFilterCharacteristic(getCharacteristic('color'), product);
  const memory = parseFilterCharacteristic(getCharacteristic('memory'), product);
  const brand = (_getCharacteristic = getCharacteristic('brand')) === null || _getCharacteristic === void 0 ? void 0 : _getCharacteristic.value;
  const prices = product.productPrice.map((priceItem, index) => {
    var _product$productTerm$, _product$productTerm, _product$productTerm2, _productTerm$duration, _priceItem$productPri2;
    const productTerm = (_product$productTerm$ = (_product$productTerm = product.productTerm) === null || _product$productTerm === void 0 ? void 0 : _product$productTerm[index]) !== null && _product$productTerm$ !== void 0 ? _product$productTerm$ : (_product$productTerm2 = product.productTerm) === null || _product$productTerm2 === void 0 ? void 0 : _product$productTerm2.find(t => t.description === _constants.PRICE_TYPES.RECURRING);
    const priceObj = {
      priceValue: priceItem.price.taxIncludedAmount.value,
      priceUnit: priceItem.price.taxIncludedAmount.unit,
      priceType: priceItem.priceType,
      durationAmount: productTerm === null || productTerm === void 0 ? void 0 : (_productTerm$duration = productTerm.duration) === null || _productTerm$duration === void 0 ? void 0 : _productTerm$duration.amount,
      durationUnit: productTerm === null || productTerm === void 0 ? void 0 : productTerm.duration.units,
      discountPriceAlteration: getDiscountPriceAlteration(priceItem, category),
      onlineDiscountPriceAlteration: priceItem === null || priceItem === void 0 ? void 0 : (_priceItem$productPri2 = priceItem.productPriceAlteration) === null || _priceItem$productPri2 === void 0 ? void 0 : _priceItem$productPri2.find(price => price.priceType === _constants.PRICE_TYPES.ONLINE_DISCOUNT)
    };
    if (priceObj.discountPriceAlteration) {
      var _priceObj$discountPri, _priceObj$discountPri2, _priceObj$discountPri3, _priceObj$onlineDisco, _priceObj$onlineDisco2, _priceObj$onlineDisco3;
      const discountPrice = (priceObj === null || priceObj === void 0 ? void 0 : (_priceObj$discountPri = priceObj.discountPriceAlteration) === null || _priceObj$discountPri === void 0 ? void 0 : (_priceObj$discountPri2 = _priceObj$discountPri.price) === null || _priceObj$discountPri2 === void 0 ? void 0 : (_priceObj$discountPri3 = _priceObj$discountPri2.taxIncludedAmount) === null || _priceObj$discountPri3 === void 0 ? void 0 : _priceObj$discountPri3.value) || 0;
      const onlineDiscountPrice = (priceObj === null || priceObj === void 0 ? void 0 : (_priceObj$onlineDisco = priceObj.onlineDiscountPriceAlteration) === null || _priceObj$onlineDisco === void 0 ? void 0 : (_priceObj$onlineDisco2 = _priceObj$onlineDisco.price) === null || _priceObj$onlineDisco2 === void 0 ? void 0 : (_priceObj$onlineDisco3 = _priceObj$onlineDisco2.taxIncludedAmount) === null || _priceObj$onlineDisco3 === void 0 ? void 0 : _priceObj$onlineDisco3.value) || 0;
      const discountValue = priceObj.priceValue - discountPrice;
      const onlineDiscountValue = priceObj.priceValue - onlineDiscountPrice;
      const discountPricePercentage = Math.round(discountPrice / priceObj.priceValue * 100);
      const onlineDiscountPricePercentage = Math.round(onlineDiscountPrice / priceObj.priceValue * 100);
      const discount = {
        discountPrice,
        onlineDiscountPrice,
        discountValue,
        onlineDiscountValue,
        discountPricePercentage,
        onlineDiscountPricePercentage,
        totalDiscountValue: priceObj.priceValue - discountPrice - onlineDiscountPrice,
        totalDiscountPercentage: discountPricePercentage + onlineDiscountPricePercentage
      };
      priceObj.discount = discount;
    }
    return priceObj;
  });
  const price = prices;
  const discountedPrice = prices.find(price => price.priceType === _constants.PRICE_TYPES.DISCOUNT);
  const characteristics = product.productCharacteristic.filter(characteristic => characteristic.value !== undefined).map(characteristic => parseProductCharacteristic(characteristic, specGroups));
  const groupedCharacteristics = getGroupedCharacteristics(characteristics);
  const mainCharacteristics = getMainCharacteristics(characteristics);
  const matchValue = Math.floor(((_getCharacteristic2 = getCharacteristic('productScore')) === null || _getCharacteristic2 === void 0 ? void 0 : (_getCharacteristic2$v = _getCharacteristic2.value) === null || _getCharacteristic2$v === void 0 ? void 0 : (_getCharacteristic2$v2 = _getCharacteristic2$v[0]) === null || _getCharacteristic2$v2 === void 0 ? void 0 : _getCharacteristic2$v2.value) * 100);
  const matchSpecs = characteristics.filter(characteristic => {
    var _characteristic$chara7;
    return characteristic === null || characteristic === void 0 ? void 0 : (_characteristic$chara7 = characteristic.characteristicRelationship) === null || _characteristic$chara7 === void 0 ? void 0 : _characteristic$chara7.find(relationship => relationship.id === 'matchingSpec');
  });
  return {
    variantId,
    media,
    brand,
    color,
    memory,
    price,
    discountedPrice,
    characteristics,
    groupedCharacteristics,
    mainCharacteristics,
    matchValue,
    matchSpecs,
    productName,
    productDescription
  };
};
function sortImages(a, b) {
  const imageOrder = ['front', 'left', 'right', 'side', 'back'];
  return imageOrder.indexOf(a.name) - imageOrder.indexOf(b.name);
}
const createVariants = (productRecommendation, category, specGroups) => {
  var _mainProduct$productR3, _mainProduct$productR4, _mainProduct$productR5;
  const mainProduct = productRecommendation.recommendationItem[0].product;
  const attachment = productRecommendation.attachment.sort(sortImages);
  const mainVariant = createVariant(mainProduct, attachment, specGroups, category);
  mergeMainProductToVariants(mainProduct);
  const variants = (_mainProduct$productR3 = (_mainProduct$productR4 = mainProduct.productRelationship) === null || _mainProduct$productR4 === void 0 ? void 0 : (_mainProduct$productR5 = _mainProduct$productR4.filter(relationshipItem => {
    return relationshipItem.relationshipType === 'alternative';
  })) === null || _mainProduct$productR5 === void 0 ? void 0 : _mainProduct$productR5.map(relationshipItem => createVariant(relationshipItem.product, attachment, specGroups, category))) !== null && _mainProduct$productR3 !== void 0 ? _mainProduct$productR3 : [];
  return [mainVariant, ...variants];
};
const parseRecommendationItem = (recommendationItem, category, specGroups) => {
  var _recommendationItem$c, _recommendationItem$r;
  const tier = getRecommendationTier(recommendationItem);
  const productId = recommendationItem.id;
  const productName = recommendationItem.name;
  const productDescription = recommendationItem.description;
  const productType = category;
  const productSubType = (_recommendationItem$c = recommendationItem.category.find(categoryItem => categoryItem['@type'] === 'subclass')) === null || _recommendationItem$c === void 0 ? void 0 : _recommendationItem$c.name;
  const variants = createVariants(recommendationItem, category, specGroups);
  const filterTree = createFilterTree(variants, category);
  const productRelationship = recommendationItem === null || recommendationItem === void 0 ? void 0 : (_recommendationItem$r = recommendationItem.recommendationItem[0]) === null || _recommendationItem$r === void 0 ? void 0 : _recommendationItem$r.product.productRelationship;
  return {
    tier,
    productId,
    productName,
    productDescription,
    productType,
    productSubType,
    variants,
    selectedVariant: chooseSelectedVariant(variants) || variants[0],
    filterTree,
    productRelationship
  };
};
const chooseSelectedVariant = variants => {
  return variants.find(variant => {
    var _variant$color2, _variant$color2$value, _variant$color2$value2;
    return variant === null || variant === void 0 ? void 0 : (_variant$color2 = variant.color) === null || _variant$color2 === void 0 ? void 0 : (_variant$color2$value = _variant$color2.value) === null || _variant$color2$value === void 0 ? void 0 : (_variant$color2$value2 = _variant$color2$value.find(c => c.isDefault)) === null || _variant$color2$value2 === void 0 ? void 0 : _variant$color2$value2.value.split('|')[0];
  });
};
const getHandsetsFromResponse = response => {
  return response.filter(item => item.category.find(categoryItem => categoryItem.id === 'handset') && item.category.find(categoryItem => categoryItem['@type'] === 'tier'));
};
const getPlansFromResponse = response => {
  return response.filter(item => item.category.find(categoryItem => categoryItem.id === 'plan') && item.category.find(categoryItem => categoryItem['@type'] === 'tier'));
};
const getBroadbandsFromResponse = response => {
  return response.filter(item => item.category.find(categoryItem => categoryItem.id === 'broadband') && item.category.find(categoryItem => categoryItem['@type'] === 'tier'));
};
const getBusinessSolutionsFromResponse = response => {
  return response.filter(item => item.category.find(categoryItem => categoryItem.id === 'business-solution') && item.category.find(categoryItem => categoryItem['@type'] === 'tier'));
};
const parseRecommendationResponse = (response, productCatalogConfig) => {
  config = productCatalogConfig;
  const responseHandsets = getHandsetsFromResponse(response);
  const responsePlans = getPlansFromResponse(response);
  const responseBroadbands = getBroadbandsFromResponse(response);
  const responseBusinessSolutions = getBusinessSolutionsFromResponse(response);
  const handsets = responseHandsets.map(recommendationProduct => parseRecommendationItem(recommendationProduct, 'handset', config.specGroups));
  const plans = responsePlans.map(recommendationProduct => parseRecommendationItem(recommendationProduct, 'plan', config.specGroups));
  const broadbands = responseBroadbands.map(recommendationProduct => parseRecommendationItem(recommendationProduct, 'broadband', config.specGroups));
  const businessSolutions = responseBusinessSolutions.map(recommendationProduct => parseRecommendationItem(recommendationProduct, 'business-solution', config.specGroups));
  return {
    handsets,
    plans,
    broadbands,
    businessSolutions
  };
};
exports.parseRecommendationResponse = parseRecommendationResponse;